module.exports = __webpack_public_path__ + "static/media/fonz1.7f5b6039.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/global/slider/fonz1.png
// module id = 152
// module chunks = 0